import { Injectable } from "@angular/core";
import{  Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
import { HttpClientModule, HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable()
export class OptionService {
    public url;

    constructor(private _http: HttpClient){
        this.url = GLOBAL.url;
        
    }

    getServices(): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json',

        });
        return this._http.get(this.url+'get/services', {headers: headers})
    }               
                

}




